import { queryPost } from "@/core/service/api";

const standardtable = {
  namespaced: true,
  name: "home",
  state: {
    data: {
      list: [],
      pagination: {
        current: 1,
        pageSize: 10
      }
    },
    loading: false
  },
  mutations: {
    save(state, { payload }) {
      Object.assign(state, {
        ...payload,
        loading: false
      });
    }
  },
  actions: {
    async query({ commit }, { payload }) {
      const response = await queryPost(payload, "/vvvrrr");
      if (response) {
        const { code, body } = response;
        if (code === 200) {
          commit({
            type: "save",
            payload: {
              data: body
            }
          });
        }
      }
    }
  }
};

export default standardtable;
